module.exports = __webpack_public_path__ + "img/slide-3.4b0735a.webp";